document.addEventListener("DOMContentLoaded", function () {

    let chatWidget = null;
    let isChatVisibleByScroll = false;
    let isCartDrawerCurrentlyOpen = false; // Still needed for state

    /**
     * Applies visibility styles to the chat widget.
     * @param {boolean} isVisible - Whether the widget should be visible.
     */
    function setChatWidgetVisibility(isVisible) {
        if (chatWidget) {
            chatWidget.style.opacity = isVisible ? "1" : "0";
            chatWidget.style.transform = isVisible ? "translateY(0)" : "translateY(10px)";
            chatWidget.style.pointerEvents = isVisible ? "auto" : "none";
        }
    }

    /**
     * Determines final chat visibility based on scroll and drawer state.
     */
    function updateChatVisibility() {
        if (!chatWidget) return;

        if (isCartDrawerCurrentlyOpen) {
            setChatWidgetVisibility(false); // Hide if drawer is open
        } else {
            setChatWidgetVisibility(isChatVisibleByScroll); // Show/hide based on scroll
        }
    }

    /* ESB hide the live chat button until scrolled past header */
    function setupScrollBasedChatHiding() {
        chatWidget = document.querySelector("inbox-online-store-chat");
        const heroSection = document.querySelector(".group--header");

        if (!chatWidget) {
            console.warn("❌ Shopify chat widget not found for scroll logic. Retrying...");
            setTimeout(setupScrollBasedChatHiding, 1000);
            return;
        }
        if (!chatWidget.style.transition) {
             chatWidget.style.transition = "opacity 0.4s ease-in-out, transform 0.4s ease-in-out";
        }
        console.log("✅ Shopify chat widget detected for scroll logic!");

        if (!heroSection) {
            console.warn("❌ Hero section not found for scroll logic! Chat will always follow scroll.");
            isChatVisibleByScroll = window.scrollY > 100;
            // updateChatVisibility(); // Don't call initial update here yet
            window.addEventListener("scroll", function () {
                isChatVisibleByScroll = window.scrollY > 100;
                updateChatVisibility();
            });
            return; // Stop if hero not found
        }

        // Normal scroll listener
        window.addEventListener("scroll", function () {
            const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
            const shouldBeVisible = window.scrollY > heroBottom;
            if (shouldBeVisible !== isChatVisibleByScroll) {
                isChatVisibleByScroll = shouldBeVisible;
                updateChatVisibility();
            }
        });

        // Set initial scroll state
        isChatVisibleByScroll = window.scrollY > (heroSection.offsetTop + heroSection.offsetHeight);
        // Initial visibility check will happen after drawer state check
    }
    /* end ESB hide the live chat button until scrolled past header */


    /* == NEW == Listen for Drawer Trigger Clicks */

    // Helper function to check if the drawer is currently open
    // (Still useful for initial check)
    function checkIsDrawerOpen(drawer) {
        if (!drawer) return false; // Handle case where drawer isn't found
        return drawer.classList.contains('active') ||
               drawer.classList.contains('is-open') ||
               drawer.classList.contains('drawer--is-open') ||
               !drawer.hasAttribute('hidden') ||
               drawer.getAttribute('aria-hidden') === 'false';
    }

    function setupDrawerEventListeners() {
        // Selectors for elements that OPEN the drawer
        const drawerOpenTriggers = document.querySelectorAll(
            '.site-header__cart a, .site-header__cart button, .header__icon--cart, a[href="/cart"], button[aria-controls="cart-drawer"], #cart-icon-bubble'
        );

        // Selector for elements that CLOSE the drawer (typically inside the drawer)
        // Use a more specific selector if possible, e.g., within #cart-drawer
        const drawerCloseTriggers = document.querySelectorAll(
            '#cart-drawer .drawer__close, #cart-drawer [data-drawer-to-close="cart-drawer"], #cart-drawer button[aria-label*="Close"]'
            // Add more specific selectors for your theme's close button/overlay if needed
        );

        // Check initial drawer state on load
        const cartDrawerElement = document.getElementById("cart-drawer");
        isCartDrawerCurrentlyOpen = checkIsDrawerOpen(cartDrawerElement);
        console.log(`[Chat Hider] Initial drawer state. Is open: ${isCartDrawerCurrentlyOpen}`);

        // --- Attach Listeners ---

        if (drawerOpenTriggers.length > 0) {
            drawerOpenTriggers.forEach(trigger => {
                trigger.addEventListener('click', function() {
                    // Assume drawer is opening *after* this click action happens
                    // Use a tiny delay to allow theme JS to potentially start the opening
                    setTimeout(() => {
                        if (!isCartDrawerCurrentlyOpen) { // Only update if state changes
                             console.log("[Chat Hider] Drawer open trigger clicked.");
                             isCartDrawerCurrentlyOpen = true;
                             updateChatVisibility();
                        }
                    }, 50); // Small delay
                });
            });
            console.log(`✅ Attached listeners to ${drawerOpenTriggers.length} drawer open triggers.`);
        } else {
            console.warn("❌ Could not find any drawer open triggers.");
        }

        if (drawerCloseTriggers.length > 0) {
             drawerCloseTriggers.forEach(trigger => {
                 trigger.addEventListener('click', function() {
                     // Assume drawer is closing *after* this click action happens
                    setTimeout(() => {
                         if (isCartDrawerCurrentlyOpen) { // Only update if state changes
                             console.log("[Chat Hider] Drawer close trigger clicked.");
                             isCartDrawerCurrentlyOpen = false;
                             updateChatVisibility();
                         }
                    }, 50); // Small delay
                 });
             });
             console.log(`✅ Attached listeners to ${drawerCloseTriggers.length} drawer close triggers.`);
        } else {
             console.warn("❌ Could not find any drawer close triggers inside #cart-drawer.");
        }

        // Add listener for potential overlay close (often attached to document or drawer parent)
        // This is less reliable and might need theme-specific adjustment
        document.addEventListener('click', function(event){
            // Check if drawer is open AND the click was OUTSIDE the drawer content AND NOT on an open trigger
            const drawerContent = cartDrawerElement?.querySelector('.drawer__inner'); // Find the actual content area
            if ( isCartDrawerCurrentlyOpen &&
                 cartDrawerElement &&
                 !cartDrawerElement.contains(event.target) && // Click outside drawer element
                 !Array.from(drawerOpenTriggers).some(trigger => trigger.contains(event.target)) // Not on an open trigger
               ) {
                 // Check if it's likely an overlay click (theme-dependent)
                 // Often the click target might be the #cart-drawer element itself or its direct parent
                 if(event.target === cartDrawerElement || event.target === cartDrawerElement?.parentElement){
                     console.log("[Chat Hider] Potential overlay click detected.");
                     isCartDrawerCurrentlyOpen = false;
                     updateChatVisibility();
                 }
            }
        });

    }
    /* == END NEW == Listen for Drawer Trigger Clicks */


    // --- Initialize features ---
    setupScrollBasedChatHiding(); // Sets up chat widget and scroll listener
    setupDrawerEventListeners(); // Sets up drawer listeners and initial state check
    // --------------------------

    // Initial visibility check AFTER both initial states are known
    // Needs a slight delay to ensure chatWidget is found by setupScrollBasedChatHiding if it retries
    setTimeout(updateChatVisibility, 1100); // Delay slightly longer than the chat widget retry timeout


    /* ESB show mobile menu sub items by default */
    function toggleMobileSubmenus() {
        // ... (rest of this function is unchanged) ...
    }
    toggleMobileSubmenus(); // Run on page load
    window.addEventListener('resize', toggleMobileSubmenus); // Re-run when resizing
    /* end ESB show mobile menu sub items by default */




});